import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Platform } from '@angular/cdk/platform';

// Define the default config
const DEFAULT_CONFIG = {
    layout          : {
        navigation      : 'left', // 'right', 'left', 'top', 'none'
        navigationFolded: false, // true, false
        toolbar         : 'below', // 'above', 'below', 'none'
        footer          : 'below', // 'above', 'below', 'none'
        mode            : 'fullwidth' // 'boxed', 'fullwidth'
    },
    colorClasses    : {
        toolbar: 'mat-white-500-bg',
        navbar : 'mat-fuse-dark-700-bg',
        footer : 'mat-fuse-dark-900-bg'
    },
    customScrollbars: true,
    routerAnimation : 'fadeIn' // fadeIn, slideUp, slideDown, slideRight, slideLeft, none
};

// Create the injection token for the custom config
export const FUSE_CONFIG = new InjectionToken('fuseCustomConfig');

@Injectable()
export class FuseConfigService
{
    config: any;
    defaultConfig: any;
    storedConfig: any;
    onConfigChanged: BehaviorSubject<any>;

    /**
     * Constructor
     *
     * @param router
     * @param platform
     * @param config
     */
    constructor(
        private router: Router,
        public platform: Platform,
        @Inject(FUSE_CONFIG) @Optional() config
    )
    {
        this.defaultConfig = DEFAULT_CONFIG;

        if ( config )
        {
            this.storedConfig = JSON.parse(localStorage.getItem(config.layoutConfig));
            if (this.storedConfig) {
                config.layout = this.storedConfig.layout;
                config.colorClasses = this.storedConfig.colorClasses;
                this.defaultConfig = config;
            } else {
                this.defaultConfig = config;
                const conf = {
                    layout : { 
                        ...config.layout
                    }, 
                    colorClasses: {
                        ...config.colorClasses
                    }
                };
                localStorage.setItem(config.layoutConfig, JSON.stringify(conf));
            }
        }

        if ( this.platform.ANDROID || this.platform.IOS )
        {
            this.defaultConfig.customScrollbars = false;
        }

        this.config = {...this.defaultConfig};

        // Reload the default settings for the
        // layout on every navigation start
        router.events.subscribe(
            (event) => {
                if ( event instanceof NavigationStart )
                {
                     this.setConfig({
                            layout: this.config.layout
                        }
                    ); 
                }
            }
        );

        // Create the behavior subject
        this.onConfigChanged = new BehaviorSubject(this.config);
    }

    refreshConfig() {
       if (this.storedConfig) {
           this.setConfig(this.storedConfig);
       } else {
        const conf = {
            layout : { 
                ... this.defaultConfig.layout
            }, 
            colorClasses: {
                ... this.defaultConfig.colorClasses
            }
        };
        this.setConfig(conf);
       }
    }

    /**
     * Set the new config from given object
     *
     * @param config
     */
    setConfig(config, save = false): void
    {
        this.config = {
            ...this.config,
            ...config,
            layout     : {
                ...this.config.layout,
                ...config.layout,
            },
            colorClasses: {
                ...this.config.colorClasses,
                ...config.colorClasses
            }
        };
        if (save) {
            const conf = {
                layout : { 
                    ...this.config.layout, 
                    ...config.layout
                }, 
                colorClasses: {
                    ...this.config.colorClasses,
                    ...config.colorClasses
                }
            };
            localStorage.setItem(this.config.layoutConfig, JSON.stringify(conf));
        }
        this.onConfigChanged.next(this.config);
    }
}




// WEBPACK FOOTER //
// ./src/@fuse/services/config.service.ts